/*
  Betriebsseite: Verifizierung, Nachweise, Angaben und Google-Bewertungen
  (Änderungsauftrag 2, Abschnitt 3; Google-Bewertungen nach
  Entscheidung Michel vom 21.09.2026).

  Änderungsauftrag 2, Abschnitt 3: drei Bloecke.
    Verifiziert  Abgleiche mit Quelle und "Stand" (seit Änderungsauftrag 5 ueber die Funktion verzeichnis)
    Nachweise    Angaben mit Herkunft "nachweis": "Nachweis liegt SolarOutlet vor"
    Angaben      Angaben mit Herkunft "betrieb" (ohne Zeilenhinweis, die Ueberschrift sagt es; Michel 29.09.2026)
  Angaben mit Herkunft "abgleich" werden nicht mehr gezeigt.

  Google-Bewertungen holt die Funktion google-bewertungen live; gespeichert
  wird nichts. Quelle und Autorinnen/Autoren werden genannt.
*/
(function () {
  'use strict';

  // Änderungsauftrag 2, Abschnitt 3: drei Bloecke
  var ARTEN = [
    ['handelsregister', 'Handelsregister: eingetragen'],
    ['ust_id', 'USt-IdNr.: gültig (EU-Register VIES)'],
    ['google_profil', 'Google-Unternehmensprofil: aktiv'],
    ['webseite', 'Webseite: erreichbar'],
    ['mail_domain', 'Webseite und Mailadresse passen zusammen'],
    ['impressum_mail', 'Mailadresse steht im Impressum der Webseite']
  ];

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function datum(iso) {
    var d = new Date(iso);
    return isNaN(d) ? '' : ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
  }
  function zeile(text, hinweis, art) {
    return '<li class="inst-angabe inst-angabe--' + art + '"><span class="inst-angabe__wert">' + esc(text) +
      '</span>' + (hinweis ? '<span class="inst-angabe__herkunft">' + esc(hinweis) + '</span>' : '') + '</li>';
  }
  function leer(t) { return '<li class="inst-angaben__laedt">' + t + '</li>'; }

  // Änderungsauftrag 5: Die Angaben kommen je Handle ueber die Funktion "verzeichnis",
  // die Sichten sind fuer den oeffentlichen Schluessel geschlossen. Keine Supabase ID im Quelltext.
  function angaben(el) {
    var url = (el.getAttribute('data-supabase-url') || '').replace(/\/+$/, '');
    var key = el.getAttribute('data-supabase-key') || '';
    var handle = el.getAttribute('data-handle') || '';
    var b1 = el.querySelector('[data-inst-block="verifiziert"]');
    var b2 = el.querySelector('[data-inst-block="nachweise"]');
    var b3 = el.querySelector('[data-inst-block="angaben"]');
    function fehler() { if (b1) b1.innerHTML = leer('Gerade nicht abrufbar.'); }
    function zeigen(block, zeilen) {
      if (!block || !zeilen.length) return;
      block.innerHTML = zeilen.join('');
      var teil = block.closest('[data-inst-teil]');
      if (teil) teil.hidden = false;
    }
    if (!url || !key || !/^[a-z0-9-]+$/.test(handle)) return fehler();
    fetch(url + '/functions/v1/verzeichnis', {
      method: 'POST',
      headers: { apikey: key, 'Content-Type': 'application/json' },
      body: JSON.stringify({ art: 'profil', handle: handle })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
      if (!j || j.status !== 'ok') throw 0;
      var verif = {}; (j.verifiziert || []).forEach(function (v) { verif[v.art] = v.stand; });
      var v = ARTEN.filter(function (a) { return verif[a[0]]; }).map(function (a) { return zeile(a[1], 'Stand ' + datum(verif[a[0]]), 'abgleich'); });
      var n = (j.nachweise || []).map(function (w) { return zeile(w, 'Nachweis liegt SolarOutlet vor', 'nachweis'); });
      var g = (j.angaben || []).map(function (w) { return zeile(w, '', 'betrieb'); });
      b1.innerHTML = v.join('') || leer('Gerade nicht abrufbar.');
      // Leere Abschnitte bleiben verborgen (Michel 29.09.2026)
      zeigen(b2, n);
      zeigen(b3, g);
    }).catch(fehler);
  }

  function sterne(n) {
    var voll = Math.round(n || 0);
    var s = '';
    for (var i = 1; i <= 5; i++) s += '<span class="inst-stern' + (i <= voll ? ' inst-stern--an' : '') + '">★</span>';
    return '<span class="inst-sterne" aria-hidden="true">' + s + '</span>';
  }

  function google(el) {
    var url = (el.getAttribute('data-supabase-url') || '').replace(/\/+$/, '');
    var key = el.getAttribute('data-supabase-key') || '';
    var inhalt = el.querySelector('[data-inst-google-inhalt]');
    if (!url || !key || !inhalt) return;
    fetch(url + '/functions/v1/google-bewertungen', {
      method: 'POST',
      headers: { apikey: key, 'Content-Type': 'application/json' },
      body: JSON.stringify({ handle: el.getAttribute('data-handle') })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || j.status !== 'ok') return;
        var link = el.querySelector('[data-inst-google-link]');
        if (link && j.url) { link.href = j.url; link.hidden = false; }
        var html = '<p class="inst-google__schnitt">' + sterne(j.bewertung) +
          '<strong>' + Number(j.bewertung).toFixed(1).replace('.', ',') + '</strong> von 5 · ' + j.anzahl + ' Bewertungen auf Google</p>';
        if (j.rezensionen && j.rezensionen.length) {
          html += '<ul class="inst-google__liste">' + j.rezensionen.map(function (x) {
            var name = x.profil
              ? '<a href="' + esc(x.profil) + '" target="_blank" rel="noopener nofollow">' + esc(x.name) + '</a>'
              : esc(x.name);
            return '<li class="inst-google__rezension">' +
              '<p class="inst-google__kopf">' + (x.foto ? '<img src="' + esc(x.foto) + '" alt="" width="28" height="28" loading="lazy" referrerpolicy="no-referrer">' : '') +
              '<span>' + name + '<small>' + esc(x.wann) + '</small></span>' + sterne(x.sterne) + '</p>' +
              '<p class="inst-google__text">' + esc(x.text) + '</p></li>';
          }).join('') + '</ul>';
        }
        inhalt.innerHTML = html;
        el.hidden = false;
      })
      .catch(function () {});
  }

  // Eintrag melden im Popup (Michel 29.09.2026): Warndreieck neben dem Namen oeffnet den Dialog
  function melden() {
    var dialog = document.querySelector('[data-inst-melden-dialog]');
    var knopf = document.querySelector('[data-inst-melden-oeffnen]');
    if (!dialog || !knopf || knopf.dataset.instBereit) return;
    knopf.dataset.instBereit = '1';
    knopf.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      var feld = dialog.querySelector('input:not([type=hidden]):not([tabindex="-1"]), textarea');
      if (feld) feld.focus();
    });
    dialog.querySelectorAll('[data-inst-melden-schliessen]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
    });
    // Klick auf den abgedunkelten Hintergrund schliesst
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  }

  function start() {
    melden();
    document.querySelectorAll('[data-inst-angaben]').forEach(function (el) {
      if (!el.dataset.instBereit) { el.dataset.instBereit = '1'; angaben(el); }
    });
    document.querySelectorAll('[data-inst-google]').forEach(function (el) {
      if (!el.dataset.instBereit) { el.dataset.instBereit = '1'; google(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
